import React from 'react';
import { connect } from 'react-redux';
import { setInput } from '../Redux/actions';
import './SearchBar.css';

class SearchBar extends React.Component {
  
  handleChange = (event) => {
    this.props.setInput(event.target.value)
  }
  
  render() {
    return (
      <div id="searchBar">
        <form>
          <input 
            type="text" 
            id="input"
            placeholder="Search" 
            value={this.props.input.input}
            onKeyPress={(event)=> { 
              if (event.key === 'Enter') 
                event.preventDefault();
                this.props.setInput(this.props.input.input);
              }}
            onChange={this.handleChange} />
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => ({
	input: state.input
});

const dispatch = {
  setInput
}

export default connect(mapStateToProps, dispatch)(SearchBar);